export const light = {
  alternate: {
    main: '#fff5f5',
    dark: '#ffebeb',
  },
  cardShadow: 'rgba(183, 28, 28, .15)',
  mode: 'light',
  primary: {
    main: '#b71c1c',
    light: '#c62828',
    dark: '#8b0000',
    contrastText: '#fff',
  },
  secondary: {
    light: '#424242',
    main: '#212121',
    dark: '#000000',
    contrastText: '#fff',
  },
  text: {
    primary: '#1a1a1a',
    secondary: '#424242',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#fafafa',
    level1: '#fff',
  },
};

export const dark = {
  alternate: {
    main: '#1a0a0a',
    dark: '#0d0505',
  },
  cardShadow: 'rgba(0, 0, 0, .2)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark',
  primary: {
    main: '#c62828',
    light: '#e53935',
    dark: '#b71c1c',
    contrastText: '#fff',
  },
  secondary: {
    light: '#616161',
    main: '#212121',
    dark: '#000000',
    contrastText: '#fff',
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#B0B0B0',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#1a1a1a',
    default: '#0d0d0d',
    level2: '#212121',
    level1: '#2d2d2d',
  },
};
